import { render } from "./CIconLeftRight.vue?vue&type=template&id=af546da8&scoped=true&ts=true"
import script from "./CIconLeftRight.vue?vue&type=script&lang=ts"
export * from "./CIconLeftRight.vue?vue&type=script&lang=ts"

import "./CIconLeftRight.vue?vue&type=style&index=0&id=af546da8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af546da8"]])

export default __exports__